import { Monogram } from "./Monogram";

export const Splash = ({ text = "One moment…" }) => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-paper gap-4">
    <Monogram size={56} className="animate-pulse" />
    <p className="font-sans text-sm text-stone">{text}</p>
  </div>
);
